import React, { useRef } from 'react';
import { useDrag, useDrop } from 'react-dnd';
import { PBNEW_NEWSLETTER_ITEM } from '../constants';

// One draggable row in the Create-newsletter ordering list.
function OrderRow({ item, index, onReorder, onDragStart }) {
  const ref = useRef(null);

  const [{ isDragging }, dragRef] = useDrag(() => ({
    type: PBNEW_NEWSLETTER_ITEM,
    item: () => {
      // ORD-02 / answer C2: manual_order_locked flips on an actual drag, never
      // on the order the administrator happened to tick the checkboxes in.
      onDragStart();
      return { index };
    },
    collect: (monitor) => ({ isDragging: monitor.isDragging() }),
  }), [index, onDragStart]);

  const [, dropRef] = useDrop(() => ({
    accept: PBNEW_NEWSLETTER_ITEM,
    hover: (dragged) => {
      if (dragged.index === index || dragged.index == null) return;
      onReorder(dragged.index, index);
      dragged.index = index;
    },
  }), [index, onReorder]);

  dragRef(dropRef(ref));

  return (
    <div
      ref={ref}
      className="pbnew-nl-order-row"
      style={{ opacity: isDragging ? 0.4 : 1 }}
      data-testid={`newsletter-order-row-${item.bucketStoryId}`}
    >
      <span className="pbnew-nl-order-handle" aria-hidden="true">⠿</span>
      <span className="pbnew-nl-order-index">{index + 1}</span>
      <span className="pbnew-nl-order-title">{item.title || 'Untitled story'}</span>
    </div>
  );
}

/**
 * The ordered list of selected stories (PRD §4.2).
 *
 * Shown in the bucket's current display order. Reordering here is binding; if
 * the administrator never drags, the assembly model may choose its own order.
 */
export default function NewsletterOrderList({ items, onReorder, onDragStart }) {
  return (
    <div className="pbnew-nl-order-list">
      {items.map((item, index) => (
        <OrderRow
          key={item.bucketStoryId}
          item={item}
          index={index}
          onReorder={onReorder}
          onDragStart={onDragStart}
        />
      ))}
    </div>
  );
}
